import VerifyEmailSuccess from "../components/VerifyEmailSuccess/VerifyEmailSuccess";

const VerifyEmailSuccessContainer = () => {
  return <VerifyEmailSuccess />;
};

export default VerifyEmailSuccessContainer;
